/* Copyright (c) 2020-present CloudIO Inc */

import type { TypographyProps } from '@mui/material';

export const TypographyEllipsisProps: TypographyProps<'div'> & {
  component: 'div';
} = {
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  component: 'div', // this is to avoid the console warning as div is not allowed inside p. since we are using UserPic inside Typography, we need to use div
};
